var _styled;

import styled from 'react-emotion';
import { MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var RightHandSide = styled('div')((_styled = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  marginTop: SPACING.SCALE_2
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: '66.66%',
  paddingLeft: SPACING.SCALE_3,
  marginTop: 0
}, _styled));
export default RightHandSide;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/right-hand-side/index.js
// module id = 298
// module chunks = 0